import { FeatureFlag } from '@ps/web-core-enums';
import React from 'react';

import useFeature from '@swf/core/hooks/useFeature';

const SelfExcludedBrandsList: React.FC = () => {
  const showTombolaBrand = useFeature(FeatureFlag.EnableTombolaContentCBSE);

  return (
    <ul>
      <li>PokerStars</li>
      <li>Paddy Power</li>
      <li>Betfair</li>
      <li>Sky Betting & Gaming</li>
      {showTombolaBrand && <li>Tombola</li>}
    </ul>
  );
};

export default SelfExcludedBrandsList;
